import * as React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import { Avatar, Box, Card, CardContent, Skeleton } from '@mui/material';
import { AuthContext } from '../../../context/AuthContext';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { GenericDialog } from '../../Dialogs/Dialog';
import GenericPromises from '../../../api/GenericPromises';
import { File } from '../../../interfaces/Commons/files';
import Badge from '@mui/material/Badge';
import { Divider } from '../../Commons/Divider';
import { useNotificationsStore } from '../../../store/Notifications/NotificationsStore';
import { Notifications } from './Notifications/Notifications';
import useSnackBar from '../../Commons/SnackBar/useSnackBar';
import { useNotificationStatusStore } from '../../../store/Notifications/NotificationStatusStore';

import { useCompanyStore } from '../../../store/AuthStore';
import { useNotificationDetailsStore } from '../../../store/Notifications/NotificationDetailsStore';

export default function PopMenu() {
    const [t] = useTranslation("global");
    const { user, logOut } = React.useContext(AuthContext);
    const { GenericGet, GenericGetResource } = GenericPromises();
    const { resetCompanyState } = useCompanyStore();
    const [openDialog, setOpenDialog] = React.useState(false);
    const [dataLoaded, setDataLoaded] = React.useState(false);
    const [notificationsDataLoaded, setNotificationsDataLoaded] = React.useState(false);
    const [objectId, setObjectId] = React.useState("");
    const [myProfileImage, setMyProfileImage] = React.useState<File>({ dataURL: "" });
    const navigate = useNavigate();
    const setNotifications = useNotificationsStore(state => state.setNotifications);
    const unReadNotifications = useNotificationsStore(state => state.unReadNotifications);
    const setNotificationStatuses = useNotificationStatusStore(state => state.setNotificationStatuses);
    const notificationStatus = useNotificationStatusStore(state => state.notificationStatuses);
    const notifications = useNotificationsStore(state => state.notifications);
    const setNotificationDetails = useNotificationDetailsStore(state => state.setNotificationDetails);

    const { showSnackBar, SnackbarComponent } = useSnackBar();


    React.useEffect(() => {
        if (user?.photo_id !== null && user?.user_id !== undefined) {
            GenericGet(`/files/recordId/${user.user_id}/entity/Users/schema/dbo`)
                .then(async (response) => {
                    let myFiles = response.data.data
                    if (myFiles !== undefined) {
                        for (let index = 0; index < response.data.data.length; index++) {
                            const element = response.data.data[index];
                            await GenericGet(`/files/${element.object_id}`)
                                .then(async (response1) => {
                                    element.dataURL = await `data:${element.type_of_file};base64,${response1.data.content}`;
                                });
                        }

                        if (myFiles && myFiles.length > 0) {
                            let photo: File;
                            photo = myFiles.find((photo: File) => photo.file_id === user?.photo_id) ?? {}
                            await setMyProfileImage(photo)
                            setObjectId(photo.object_id ?? '')
                            setDataLoaded(true);

                        }
                    }
                });
        }
    }, []);


    React.useEffect(() => {
        GenericGetResource(`/notificationstatuses`)
            .then(async (response) => {
                setNotificationStatuses(response.data.data);

            })
            .catch((error) => {
                showSnackBar(error.message, 'error');
            })
    }, [])

    React.useEffect(() => {
        if (notificationStatus) {
            GenericGetResource(`/notifications/byuserid/${user?.user_id}`)
                .then(async (response) => {
                    setNotifications(response.data.data);
                })
                .catch((error) => {
                    showSnackBar(error.message, 'error');
                })
        }
    }, [notificationStatus])

    React.useEffect(() => {
        if (notifications) {
            GenericGetResource(`/notificationdetails/byuserid/${user?.user_id}`)
                .then(async (response) => {
                    setNotificationDetails(response.data.data);
                })
                .catch((error) => {
                    showSnackBar(error.message, 'error');
                })
                .finally(()=>{
                    setNotificationsDataLoaded(true);

                })
        }
    }, [notifications])

    return (
        <>
            <PopupState variant="popover" popupId="demo-popup-popover">
                {(popupState) => (
                    <div>
                        <Button  {...bindTrigger(popupState)} >
                            <Badge
                                color="secondary"
                                badgeContent={unReadNotifications > 0 ? unReadNotifications : null} // Mostrar badge solo si hay notificaciones no leídas
                            >
                                <Avatar sx={{
                                    bgcolor: 'primary.main',
                                    border: '1px solid white',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }} variant='rounded' alt={user?.user_name} >
                                    {!dataLoaded && (
                                        <Typography>
                                            {user?.user_name.charAt(0)}
                                        </Typography>
                                    )}
                                    {dataLoaded && (!myProfileImage.dataURL || myProfileImage.dataURL === "") ? (
                                        <Typography>
                                            {user?.user_name.charAt(0)}
                                        </Typography>
                                    ) : (
                                        dataLoaded && myProfileImage.dataURL && (
                                            <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <img alt='profile' src={myProfileImage.dataURL} style={{ objectFit: "cover", width: '100%', height: '100%' }} />
                                            </div>
                                        )
                                    )}
                                </Avatar>
                            </Badge>
                        </Button>

                        <Popover
                            {...bindPopover(popupState)}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                        >
                            <Card>
                                <CardContent className='d-flex flex-column align-items-end' >
                                    <Button onClick={() => setOpenDialog(true)} variant='outlined'>
                                        <Typography fontSize={15}>{t("generic.logOut")}</Typography>
                                    </Button>
                                    <div className='d-flex'>
                                        <Button className='m-1' sx={{ borderRadius: 3 }} onClick={() => navigate("profile")}>
                                            <Avatar className='m-2'
                                                sx={{
                                                    bgcolor: 'transparent',
                                                    border: '1px solid white',
                                                    overflow: 'hidden',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    height: '70px',
                                                    width: '70px'
                                                }}
                                                variant='rounded' alt={user?.user_name}>
                                                {!dataLoaded && (
                                                    <Typography color={'black'}>
                                                        {user?.user_name.charAt(0)}
                                                    </Typography>
                                                )}
                                                {dataLoaded && (!myProfileImage.dataURL || myProfileImage.dataURL === "") ? (
                                                    <Typography color={'black'}>
                                                        {user?.user_name.charAt(0)}
                                                    </Typography>
                                                ) : (
                                                    dataLoaded && myProfileImage.dataURL && (
                                                        <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                            <img alt='profile' src={myProfileImage.dataURL} style={{ objectFit: "cover", width: '100%', height: '100%' }} />
                                                        </div>
                                                    )
                                                )}
                                            </Avatar>
                                        </Button>
                                        <div className='d-flex flex-column m-2'>
                                            <span>{user?.user_name}</span>
                                            <span>{user?.user_email}</span>
                                            <span>{user?.group_name}</span>
                                        </div>
                                    </div>
                                </CardContent>
                                <Divider />
                                {!notificationsDataLoaded ? (
                                    <Box position="relative" width="100%">
                                    <Skeleton variant="rectangular" width={'auto'} height={'75px'} />

                                    <Typography
                                        color="textSecondary"
                                        position="absolute"
                                        top="50%"
                                        left="50%"
                                        sx={{ transform: "translate(-50%, -50%)" }}
                                    >
                                        {t("generic.notifications.messages.loading-notifications")}
                                    </Typography>
                                </Box>
                                ) : (
                                    <Box sx={{
                                        overflowY: 'auto',
                                        maxHeight: '70vh',
                                        minHeight: 'auto'
                                    }}>
                                        <Notifications  />
                                    </Box>
                                )}
                            </Card>
                        </Popover>
                        <GenericDialog
                            open={openDialog}
                            setOpen={setOpenDialog}
                            title={t("generic.logOut")}
                            content={t("generic.logOutMessage")}
                            onAcept={async () => {
                                await localStorage.removeItem("schemaName")
                                await resetCompanyState();
                                await logOut()
                                window.location.reload();
                            }}
                        />
                    </div>
                )}
            </PopupState>
            <SnackbarComponent />
        </>
    );
}
